// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2b948704","453":"e9bd7b64"}[chunkId] + ".chunk.js";
};